<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Entregas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="tooglePesquisa">
            <v-icon>search</v-icon>
          </v-btn>
          <v-btn text @click="$router.push('/entregas/adicionar')" class="hidden-xs-only">Adicionar</v-btn>
          <v-btn icon @click="$router.push('/entregas/adicionar')" class="hidden-sm-and-up">
            <v-icon>add</v-icon>
          </v-btn>
        </v-app-bar>
        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" style="background-color: rgba(189, 189, 189, 0.3);">
            <v-col pa-2>
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                color="primary"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>
        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="entregas"
          :loading="loading"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
          :footer-props="{ itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }], itemsPerPageText: 'Registros Exibidos' }"
        >
          <template v-slot:item.acoes="{item}">
            <td>
              <v-tooltip top>
                Visualizar
                <v-btn slot="activator" icon @click="abrirDialogoEntrega(item)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <as-dialogo ref="dialogo" title="Cancelar" max-width="1200px" sem-padding hideCloseButton>
      <p>Deseja confirmar o cancelamento desta entrega?</p>
      <div slot="botoes">
        <v-btn color="primary" @click="$refs.dialogo.fechar()" :disabled="loadingCancelar">Não</v-btn>
        <v-btn color="primary" @click="cancelar" :loading="loadingCancelar">Sim</v-btn>
      </div>
    </as-dialogo>
  </div>
</template>

<script>
import ServiceEntregas from "@/services/entregas.js";
import { ptDateFormat } from "@/util/dateFormat.js";

export default {
  name: "entregas",
  data() {
    return {
      ptDateFormat,
      loading: false,
      loadingCancelar: false,
      exibirPesquisa: false,
      pesquisa: "",
      entregas: [],
      entrega: {},
      headers: [
        { text: "Número", value: "id", width: "25%" },
        { text: "Pedido", value: "pedido_id", width: "25%" },
        { text: "Cliente", value: "cliente_nome", width: "25%" },
        { text: "Representante", value: "representante_nome", width: "25%" },
        { text: "", value: "acoes", sortable: false },
      ],
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    async listar() {
      try {
        this.loading = true;
        let response = await ServiceEntregas.listar();
        this.entregas = response.data.entregas;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async cancelar() {
      try {
        this.loadingCancelar = true;
        let response = await ServiceEntregas.cancelar(this.entrega.id);
        this.listarFornecedores();
        this.$refs.dialogo.fechar();
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingCancelar = false;
      }
    },
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
  },
};
</script>
